import { createBasicSelectors } from 'modules/utils/helpers/createBasicSelectors'

const TerritorySelectors = createBasicSelectors('territory')

export default TerritorySelectors
